/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import loginBanner from "../../assets/images/Artboard7.svg";
import { RegistrationContext } from '../../context/RegistrationContext';
import Header from "../../components/home/header";
import Footer from "../../components/home/footer"
import LoginModal from "../login";
import { forgotPassword } from '../../services/authService'; // Use this to check if email exists
import Navbar from "../../components/landingpage/sections/Navbar";

const Register = (props) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { registrationData, updateRegistrationData } = useContext(RegistrationContext);
  const [formData, setFormData] = useState({
    fullName: registrationData?.fullName || '',
    userPhone: registrationData?.userPhone || '',
    email: registrationData?.email || '',
    userPassword: '',
    confirmPassword: ''
  });
  const [error, setError] = useState(null);
  const [passwordErrors, setPasswordErrors] = useState([]);
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);
  const [isPhoneFocused, setIsPhoneFocused] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleMobileLoginClick = () => {
    setShowLoginModal(true);
  };

  useEffect(() => {
    if (registrationData) {
      setFormData(prev => ({
        ...prev,
        fullName: registrationData.fullName || '',
        userPhone: registrationData.userPhone || '',
        email: registrationData.email || ''
      }));
    }
  }, [registrationData]);

  const handlePhoneChange = (phoneValue) => {
    setFormData({
      ...formData,
      userPhone: phoneValue || ''
    });

    if (phoneValue) {
      const validation = validatePhoneFormat(phoneValue);
      if (!validation.isValid) {
        setError(validation.message);
      } else {
        setError(null);
      }
    } else {
      setError(null);
    }
  };

  const handlePhoneFocus = () => {
    setIsPhoneFocused(true);
  };

  const handlePhoneBlur = () => {
    setIsPhoneFocused(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    if (name === 'userPassword') {
      validatePassword(value);
    }
  };

  const handlePasswordFocus = () => {
    setIsPasswordFocused(true);
    if (formData.userPassword) {
      validatePassword(formData.userPassword);
    }
  };

  const handlePasswordBlur = () => {
    setIsPasswordFocused(false);
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validatePassword = (password) => {
    const errors = [];

    if (password.length < 8) {
      errors.push("At least 8 characters");
    }

    if (!/(?=.*[a-z])/.test(password)) {
      errors.push("At least one lowercase letter");
    }

    if (!/(?=.*[A-Z])/.test(password)) {
      errors.push("At least one uppercase letter");
    }

    if (!/(?=.*\d)/.test(password)) {
      errors.push("At least one number");
    }

    if (!/(?=.*[@$!%*?&])/.test(password)) {
      errors.push("At least one special character (@$!%*?&)");
    }

    setPasswordErrors(errors);
    return errors.length === 0;
  };

  const validatePhoneFormat = (phone) => {
    if (!phone) return { isValid: false, message: '' };

    const cleanPhone = phone.replace(/\s+/g, '');

    if (cleanPhone.length === 13 || cleanPhone.length === 14) {
      return { isValid: true, message: '✓ Valid phone format' };
    } else if (cleanPhone.length > 14) {
      return {
        isValid: false,
        message: 'Phone number too long. Remove extra digits.'
      };
    } else if (cleanPhone.length > 5 && cleanPhone.length < 13) {
      return {
        isValid: false,
        message: 'Phone number too short. Add more digits.'
      };
    } else {
      return {
        isValid: false,
        message: 'Enter a complete phone number'
      };
    }
  };

  const checkIfUserExists = async (email) => {
    try {
      const response = await forgotPassword(email);
      return true;
    } catch (error) {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.userPhone) {
      const phoneValidation = validatePhoneFormat(formData.userPhone);
      if (!phoneValidation.isValid) {
        setError(phoneValidation.message);
        return;
      }
    }

    if (!formData.fullName || !formData.userPhone || !formData.email || !formData.userPassword || !formData.confirmPassword) {
      setError('Please fill all fields');
      return;
    }

    if (!validateEmail(formData.email)) {
      setError('Please enter a valid email address');
      return;
    }

    const isPasswordValid = validatePassword(formData.userPassword);
    if (!isPasswordValid) {
      setError('Please fix password requirements');
      return;
    }

    if (formData.userPassword !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setError(null);
    setIsLoading(true);

    try {
      const userExists = await checkIfUserExists(formData.email);
      if (userExists) {
        setError('This email is already registered. Please use a different email or login.');
        return;
      }

      const { confirmPassword, ...dataToSave } = formData;
      updateRegistrationData(dataToSave);

      navigate('/fanregisterstepone');

    } catch (err) {
      setError('Validation failed. Please check your information.');
    } finally {
      setIsLoading(false);
    }
  };

  const isPasswordValid = formData.userPassword && passwordErrors.length === 0;

  const [isPasswordVisible, setPasswordVisibility] = useState(false);
  const togglePasswordVisibility = () => {
    setPasswordVisibility(!isPasswordVisible);
  };

  return (
    <>
      <style>{`
  .dark-mode .form-control.floating:focus-within {
    background-color: #ffffff !important;
  }
  .dark-mode .form-control.floating:focus-within .PhoneInputInput {
    background-color: #ffffff !important;
  }
`}</style>
      <Navbar {...props} />
      <div className="content top-space">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <div className="account-content">
                <div className="row align-items-center justify-content-center">
                  <div className="col-md-7 col-lg-6 login-left">
                    <img src={loginBanner} className="img-fluid" alt="Register" />
                  </div>
                  <div className="col-md-12 col-lg-6 login-right">
                    <div className="login-header">
                      <h3>
                        Fan Register{" "}
                        <Link to="/celeb-register">Are you a Celebrity?</Link>
                      </h3>
                    </div>
                    {error && <div className="alert alert-danger">{error}</div>}
                    <form onSubmit={handleSubmit}>
                      <div className="form-group form-focus">
                        <input
                          type="text"
                          className="form-control floating"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleChange}
                          placeholder=" "
                          required
                        />
                        <label className="focus-label">Full Name</label>
                      </div>
                      <div className="form-group form-focus">
                        <input
                          type="email"
                          className="form-control floating"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                        <label className="focus-label">Email Address</label>
                      </div>

                      <div className="form-group form-focus mb-5" style={{ position: 'relative' }}>
                        <div className="form-control floating" style={{ padding: 0, display: 'flex', alignItems: 'center', height: '50px' }}>
                          <PhoneInput
                            international
                            defaultCountry="ZW"
                            countryCallingCodeEditable={false}
                            value={formData.userPhone}
                            onChange={handlePhoneChange}
                            onFocus={handlePhoneFocus}
                            onBlur={handlePhoneBlur}
                            placeholder=""
                            style={{
                              width: '100%',
                              border: 'none',
                              background: 'transparent',
                              outline: 'none',
                              padding: '21px 12px 6px 12px'
                            }}
                            inputStyle={{
                              width: '100%',
                              border: 'none',
                              background: 'transparent',
                              outline: 'none',
                              fontSize: '14px',
                              color: 'inherit',
                              marginLeft: '8px'
                            }}
                          />
                        </div>
                        <label className="focus-label">Mobile Number</label>

                        {/* Replace this section to show actual validation feedback */}
                        {formData.userPhone && (
                          <div className={`${validatePhoneFormat(formData.userPhone).isValid ? 'valid-feedback' : 'invalid-feedback'} d-block`}>
                            <small className={validatePhoneFormat(formData.userPhone).isValid ? 'text-success' : 'text-danger'}>
                              {validatePhoneFormat(formData.userPhone).message}
                            </small>
                          </div>
                        )}
                      </div>

                      <div className="form-group form-focus mt-6">
                        <input
                          type={isPasswordVisible ? "text" : "password"}
                          className="form-control floating"
                          name="userPassword"
                          value={formData.userPassword}
                          onChange={handleChange}
                          onFocus={handlePasswordFocus}
                          onBlur={handlePasswordBlur}
                          required
                          minLength="8"
                        />
                        <span
                          onClick={togglePasswordVisibility}
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: '#6c757d',
                            fontSize: '16px',
                            zIndex: 10
                          }}
                        >
                          {isPasswordVisible ? '🙈' : '👁️'}
                        </span>
                        <label className="focus-label">Create Password</label>

                        {/* Show password requirements only when focused or has errors */}
                        {(isPasswordFocused || formData.userPassword) && (
                          <div className="password-requirements mt-2">
                            <small className="d-block text-muted">
                              {isPasswordValid ? '✓ Password meets all requirements' : 'Password must include:'}
                            </small>
                            {!isPasswordValid && (
                              <ul className="list-unstyled mb-0" style={{ fontSize: '12px' }}>
                                <li className={formData.userPassword.length >= 8 ? 'text-success' : 'text-danger'}>
                                  {formData.userPassword.length >= 8 ? '✓ ' : '• '}
                                  At least 8 characters
                                </li>
                                <li className={/(?=.*[a-z])/.test(formData.userPassword) ? 'text-success' : 'text-danger'}>
                                  {/(?=.*[a-z])/.test(formData.userPassword) ? '✓ ' : '• '}
                                  One lowercase letter
                                </li>
                                <li className={/(?=.*[A-Z])/.test(formData.userPassword) ? 'text-success' : 'text-danger'}>
                                  {/(?=.*[A-Z])/.test(formData.userPassword) ? '✓ ' : '• '}
                                  One uppercase letter
                                </li>
                                <li className={/(?=.*\d)/.test(formData.userPassword) ? 'text-success' : 'text-danger'}>
                                  {/(?=.*\d)/.test(formData.userPassword) ? '✓ ' : '• '}
                                  One number
                                </li>
                                <li className={/(?=.*[@$!%*?&])/.test(formData.userPassword) ? 'text-success' : 'text-danger'}>
                                  {/(?=.*[@$!%*?&])/.test(formData.userPassword) ? '✓ ' : '• '}
                                  One special character (@$!%*?&)
                                </li>
                              </ul>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="form-group form-focus pass-group" style={{ position: 'relative' }}>
                        <input
                          type={isPasswordVisible ? "text" : "password"}
                          className="form-control floating"
                          name="confirmPassword"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                          required
                          minLength="8"
                        />
                        <span
                          onClick={togglePasswordVisibility}
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: '#6c757d',
                            fontSize: '16px',
                            zIndex: 10
                          }}
                        >
                          {isPasswordVisible ? '🙈' : '👁️'}
                        </span>
                        <label className="focus-label">Confirm Password</label>
                        {formData.confirmPassword && formData.userPassword !== formData.confirmPassword && (
                          <small className="text-danger">Passwords do not match</small>
                        )}
                      </div>

                      <div className="text-end">
                        <Link className="forgot-link" to="#" onClick={handleMobileLoginClick}>
                          Already have an account?
                        </Link>
                      </div>
                      <button
                        className="btn btn-primary w-100 btn-lg login-btn"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                            Validating...
                          </>
                        ) : (
                          'Continue'
                        )}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LoginModal show={showLoginModal} onHide={() => setShowLoginModal(false)} />
      </div>
      <Footer {...props} />
    </>
  );
};

export default Register;
